// src/components/JobCard.js
import React, { useState } from 'react'; // Import useState
import './JobCard.css';

// Helper function to format the date
const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    // Ensure timestamp is a Date object. Firestore Timestamps have .toDate() method.
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    if (isNaN(date.getTime())) return 'N/A'; // Check for invalid date
    return date.toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
};

const JobCard = ({ job }) => {
    const [isExpanded, setIsExpanded] = useState(false); // State to manage expansion

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div className="job-card">
            <div className="job-card-header">
                <h3 className="job-title">{job.title}</h3>
                {job.jobType === 'private' && <p className="company-name">{job.companyName}</p>}
                {job.jobType === 'government' && <p className="company-name">Government of India</p>}
            </div>

            <div className="job-card-body">
                {/* Always visible details */}
                {job.jobType === 'private' && (
                    <div className="job-detail"><strong>Role:</strong> {job.jobRole}</div>
                )}
                <div className="job-detail"><strong>Vacancies:</strong> {job.vacancies}</div>
                {job.qualification && <div className="job-detail"><strong>Qualification:</strong> {job.qualification}</div>}
                {job.eligibility && <div className="job-detail"><strong>Eligibility:</strong> {job.eligibility}</div>}
                {job.experience && <div className="job-detail"><strong>Experience:</strong> {job.experience}</div>}
                {job.salary && <div className="job-detail"><strong>Salary:</strong> {job.salary}</div>}
                {job.locationState && <div className="job-detail"><strong>Location:</strong> {job.locationState}{job.locationDistrict && `, ${job.locationDistrict}`}</div>}

                {/* Conditionally rendered details */}
                {isExpanded && (
                    <div className="job-card-expanded-details">
                        {job.description && <div className="job-detail"><strong>Description:</strong> {job.description}</div>}
                        {job.age && <div className="job-detail"><strong>Age Limit:</strong> {job.age}</div>}
                        {job.contactDetails && job.jobType === 'private' && <div className="job-detail"><strong>Contact:</strong> {job.contactDetails}</div>}
                        {job.moreInfoLink && job.jobType === 'government' && <div className="job-detail"><strong>More Info:</strong> <a href={job.moreInfoLink} target="_blank" rel="noopener noreferrer">Link</a></div>}
                        {/* Add any other fields you want to show only when expanded */}
                    </div>
                )}
            </div>

            <div className="job-card-footer">
                {job.lastDate && <span className="last-date">Last Date: {formatDate(job.lastDate)}</span>}
                {job.applyLink ? (
                    <a href={job.applyLink} target="_blank" rel="noopener noreferrer" className="apply-btn">Apply Now</a>
                ) : (
                    // Only show contact details here if not a government job and if not expanded (to avoid redundancy)
                    (!isExpanded && job.jobType === 'private' && job.contactDetails) &&
                    <span className="contact-info">Contact: {job.contactDetails}</span>
                )}
                {/* Read More / Read Less button */}
                <button onClick={toggleExpanded} className="read-more-btn">
                    {isExpanded ? 'Read Less' : 'Read More'}
                </button>
            </div>
        </div>
    );
};

export default JobCard;